import React, { createContext, useState } from "react";

const PqCommunicationContext = createContext();

const PqCommunicationProvider = ({ children }) => {
  const [globalPqDetails, setGlobalPqDetails] = useState({pqId: 0, vendorName: "", clientName: ""});
    useState(false);

  return (
    <PqCommunicationContext.Provider
      value={{
        globalPqDetails,
        setGlobalPqDetails
      }}
    >
      {children}
    </PqCommunicationContext.Provider>
  );
};

export { PqCommunicationContext, PqCommunicationProvider };
